import { useEffect, useState, useContext } from "react";
import { CartContext } from "../context/CartContext";
import { NavLink, useParams } from "react-router-dom";

import { getProductByHandle } from '../lib/shopify';
import CurrencyDisplay from "../components/CurrencyDisplay";
import getImgUrl from '../helper/getImgUrl';

import styles from "../styles/productpage.module.css";

const ProductPage = () => {
    const [detailOpen, setDetailOpen] = useState(false)
    const [materialChoice, setMaterialChoice] = useState('')
    const [picNumber, setPicNumber] = useState(0)
    const [product, setProduct] = useState(null);
    const { id } = useParams();

    const { addToCart } = useContext(CartContext);

    const fetchProduct = async () => {
        try {
            const data = await getProductByHandle(id);
            setProduct(data);
        } catch (error) {
            console.error('Error loading product', error);
        }
    };

    useEffect(() => {
        fetchProduct();
    }, [id]);

    const handleAddToCart = async () => {
        const variantId = product.variantsByMaterial[materialChoice];
        try {
            await addToCart(variantId, 1);
            setMaterialChoice('');
        } catch (error) {
            console.error('Error adding product to cart:', error);
            alert('Failed to add product to cart');
        }
    };

    return (
        <div className={styles.body_main}>
            
            <div className={styles.product_details}>
                <div className={styles.product_image_container}>
                    <div className={styles.tracer}>
                        <nav>
                            <div className={styles.tracer_div}>
                                <NavLink className={styles.navlink} to="/products">
                                    <span>Product</span>
                                </NavLink>
                            </div>  
                            <div className={styles.tracer_div}>
                                {product?.type}
                            </div> 
                            <div className={styles.tracer_div}>
                                {product?.title}
                            </div>
                        </nav>
                    </div>

                    <div className={styles.image_container}>
                        <div className={styles.carousel}>
                            {product?.images.map((img, idx) => (
                                <img
                                    key={idx}
                                    className={picNumber === idx ? styles.carouselactive : styles.carouselimg}
                                    src={getImgUrl(img, 'product')}
                                    alt=""
                                    onClick={() => setPicNumber(idx)}
                                />
                            ))}
                        </div>
                        <div className={styles.productimg}>
                            <img src={getImgUrl(product?.images[picNumber], 'product')} alt=""/>
                        </div>
                    </div>
                    
                </div>

                <div className={styles.product_info}>
                    <div className={styles.title}>
                        <h1>{product?.title}</h1>
                    </div>
                    <div className={styles.description}>
                        <p>{product?.productdesc}</p>
                    </div>

                    <div className={styles.material_price}>
                        <div className={styles.material}>
                            <div>
                                <p>Available material:</p>
                            </div>
                            <div className={styles.used_material}>
                                {product?.materials?.map((material, idx) => 
                                    <p 
                                        key={idx} 
                                        onClick={() => setMaterialChoice(material)}
                                        className={materialChoice === material ? styles.used_material_active : ""}
                                    >
                                            {`${material}`}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className={styles.price}>
                            <p>Price:</p>
                            <span><p><CurrencyDisplay amount={product?.price} currency="CAD"/></p></span>
                        </div>
                    </div>
                    

                    <button className={materialChoice === "" || product?.quantity === 0 ? styles.btndisable : styles.button_order} onClick={handleAddToCart}>{
                        product?.quantity > 0 ? 'ADD TO ORDER' :'OUT OF STOCK'
                    }
                    </button>

                    <div className={styles.accordion}>
                        <details name="productinfo" onClick={() => setDetailOpen(!detailOpen)}>
                            <summary>Shipping{detailOpen ? <span>-</span> : <span>+</span>}</summary>
                            <p>werwerwerwerwerwrwe</p>
                        </details>
                        <details name="productinfo">
                            <summary>Refund <span>+</span></summary>
                            <p>wefwefwefwefwefwefwef4323</p>
                        </details>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ProductPage